type Product = {
    product_description: string;
    quantity: number;
}

export interface ISocketState {
    job_id: string;
    user_id: string;
    quantity: number;
    latency: number;
    products: Record<string, Product>;
    end_date: string;
}

export enum IJobSocketDetailsActionTypes {

    FETCH_JOB_SOCKET_DETAILS_REQUEST = 'FETCH_JOB_SOCKET_DETAILS_REQUEST',
    FETCH_JOB_SOCKET_DETAILS_SUCCESS = 'FETCH_JOB_SOCKET_DETAILS_SUCCESS',
    FETCH_JOB_SOCKET_DETAILS_FAILURE = 'FETCH_JOB_SOCKET_DETAILS_FAILURE',
}

export type IJobSocketActionCreator = {
    type?: string;
    payload?: ISocketState;
};
